var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TabbedForm as RaTabbedForm } from 'react-admin';
import { Toolbar } from './Toolbar';
/**
 * Alternative to react-admin's <TabbedForm> that adds RBAC control to the delete button.
 *
 * Use in conjunction with ra-rbac's <FormTab> to render inputs based on permissions.
 *
 * @example
 * import { TabbedForm } from '@react-admin/ra-rbac';
 *
 * const authProvider = {
 *     checkAuth: () => Promise.resolve(),
 *     login: () => Promise.resolve(),
 *     logout: () => Promise.resolve(),
 *     checkError: () => Promise.resolve(),
 *     getPermissions: () =>Promise.resolve([
 *         // 'delete' is missing
 *         { action: ['list', 'edit'], resource: 'products' },
 *     ]),
 * };
 *
 * const ProductEdit = () => (
 *     <Edit>
 *         <TabbedForm>
 *             <FormTab label="Description">
 *                 <TextInput source="reference" />
 *                 <TextInput source="width" />
 *                 <TextInput source="height" />
 *                 <TextInput source="description" />
 *             </FormTab>
 *             <FormTab label="Images">
 *                 <TextInput source="image" />
 *                 <TextInput source="thumbnail" />
 *             </FormTab>
 *             <FormTab label="Stock">
 *                 <TextInput source="stock" />
 *             </FormTab>
 *             // delete button not displayed
 *         </TabbedForm>
 *     </Edit>
 * );
 */
export var TabbedForm = function (props) { return (React.createElement(RaTabbedForm, __assign({ toolbar: React.createElement(Toolbar, null) }, props))); };
TabbedForm.propTypes = RaTabbedForm.propTypes;
